import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { logoPath } from "../data/site";

export function CTASection() {
  return (
    <section className="relative overflow-hidden py-20 sm:py-24">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-white/[0.055] p-8 shadow-glass backdrop-blur-xl sm:p-12 lg:p-14"
        >
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_12%_18%,rgba(30,109,255,0.28),transparent_28%),radial-gradient(circle_at_90%_20%,rgba(74,24,255,0.22),transparent_30%)]" />
          <div className="relative z-10 grid gap-10 lg:grid-cols-[1fr_0.5fr] lg:items-center">
            <div>
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/70">
                <Sparkles className="h-4 w-4 text-electric" />
                Launch with confidence
              </div>
              <h2 className="max-w-3xl font-display text-3xl font-semibold leading-tight text-white sm:text-5xl">
                Ready to turn your next digital idea into a scalable product?
              </h2>
              <p className="mt-5 max-w-2xl text-base leading-7 text-white/65">
                Bring Lazerwebs into your project early. We will help clarify
                the solution, shape the experience, build the platform, and
                support your launch.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <Link to="/contact" className="btn btn-primary">
                  Start a Project
                  <ArrowRight className="h-4 w-4" />
                </Link>
                <Link to="/products" className="btn btn-secondary">
                  View Our Solutions
                </Link>
              </div>
            </div>
            <div className="relative mx-auto grid h-52 w-52 place-items-center rounded-[2rem] border border-white/10 bg-ink/70 shadow-glow">
              <img
                src={logoPath}
                alt="Lazerwebs logo"
                className="h-32 w-32 rounded-3xl object-cover"
              />
              <div className="absolute -bottom-4 left-1/2 w-40 -translate-x-1/2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-center text-xs font-semibold text-white/70 backdrop-blur-xl">
                Premium software studio
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
